module.exports = __webpack_public_path__ + "img/qanAbg.7dc54a18.jpg";